import { navigation1, focusElemnt, clickElement, customRound } from './helper'
import * as mdt from '../common/modaltypes'
import * as iid from '../common/bookingElementId'
import { safeAdd } from './mathHelper'
export const chargeFields = ['freight', 'coll_cartage', 'del_cartage', 'hamali', 'op_hamali', 'valuation', 'doc_fee', 'pickup_fee', 'dropoff_fee']

export const handleUploadButton = (e, nextId, prevId) => {
  if (e.key === 'ArrowDown') {
    e.preventDefault()
    focusElemnt(nextId)
  }
  if (e.key === 'ArrowUp') {
    e.preventDefault()
    focusElemnt(prevId)
  }
  if (e.key === 'Escape') {
    focusElemnt(prevId)
  }
}
export const handleIdSaveButton = (e, nextId, prevId) => {
  if (e.key === 'Escape' || e.key === 'ArrowUp') {
    e.preventDefault()
    focusElemnt(prevId)
  }
}

export const addRemoveKeydown = (e, nextId, prevId, i, lastIndex, updateModal, setRemoveIndex, noAdd = false) => {
  if (e.key === 'ArrowDown') {
    e.preventDefault()
    if (!lastIndex) {
      focusElemnt(iid.addRemove + (i + 1))
    }
  }
  if (e.key === 'ArrowUp') {
    e.preventDefault()
    if (i > 0) {
      focusElemnt(iid.addRemove + (i - 1))
    }
  }
  if (e.key === 'Enter') {
    e.preventDefault()
    if (lastIndex && !noAdd) {
      updateModal(true, mdt.consignmentAddPopUp)
    } else {
      setRemoveIndex(i)
      updateModal(true, mdt.consignmentDelPopUp)
    }
  }
  if (['Escape', 'ArrowRight', 'ArrowLeft'].includes(e.key)) {
    if (e.key === 'ArrowRight') e.key = 'Enter'
    if (e.key === 'ArrowLeft') e.key = 'Escape'
    navigation1(e, nextId, prevId)
  }
}
export const addRemoveKeydownForAdminUpdate = (
  e,
  nextId,
  prevId,
  i,
  lastIndex,
  setRemoveIndex,
  setAddPopup,
  setDelPopup,
  calTotalFreight
) => {
  if (e.key === 'ArrowDown') {
    e.preventDefault()
    if (!lastIndex) {
      focusElemnt(iid.addRemove + (i + 1))
    }
  }
  if (e.key === 'ArrowUp') {
    e.preventDefault()
    if (i > 0) {
      focusElemnt(iid.addRemove + (i - 1))
    }
  }
  if (e.key === 'Enter') {
    e.preventDefault()
    if (lastIndex) {
      setAddPopup(true)
    } else {
      setRemoveIndex(i)
      setDelPopup(true)
      calTotalFreight(0, i)
    }
  }
  if (e.key === 'Escape') {
    navigation1(e, nextId, prevId)
  }
}

export function splitProportionally(arr, value) {
  const total = arr.reduce((sum, num) => sum + num, 0)
  if (!total) return 0
  const result = arr.map((num) => parseFloat(((+num / total) * value).toFixed(2)))
  const diff = value - result.reduce((sum, num) => sum + num, 0)
  result[result.length - 1] += parseFloat(diff.toFixed(2))
  return result
}
export const getReverseFreight = (consignmntData, i, priceSectionData, IsRateIncludeAllCharge, rateIncrease) => {
  if (!IsRateIncludeAllCharge && !rateIncrease?.IsDefaultRateIncreasedBy) {
    return 0
  } else {
    const allFreights = consignmntData.map((a) => parseFloat(a.freight) || 0)
    const total = allFreights.reduce((sum, num) => sum + num, 0)
    if (!total) return 0
    const value = IsRateIncludeAllCharge ? getOtherCharges(priceSectionData) : 0
    const proportionalArr = splitProportionally(allFreights, value)
    const proportionalArr2 = splitProportionally(allFreights, rateIncrease?.DefaultRateIncreaseAmt || 0)
    const result = allFreights[i] - proportionalArr[i] + proportionalArr2[i]
    return parseFloat(result.toFixed(2)).toString()
  }
}
export const getOtherCharges = (d) => {
  if (!d || typeof d !== 'object') return 0
  const otherChargeID = [
    'CCBrkup_pckp',
    'CCBrkup_cmsn',
    'del_cartage',
    'hamali',
    'op_hamali',
    'valuation',
    'doc_fee',
    'pickup_fee',
    'dropoff_fee',
  ]
  const result= otherChargeID.reduce((acc, curr) => {
    const value = d[curr]
    if (value) {
      acc = safeAdd(acc, +value, 3)
    }
    return acc
  }, 0)
  return result
}

export const formatVehicleNoForFleetOp=(vehicle)=>{
  if(!vehicle) return ''
  return (vehicle + '').toUpperCase().replace(/[^A-Z0-9]/g, '')
}
function safeNumber(val) {
  const num = +val
  return Number.isFinite(num) ? num : 0
}

export const bookingGST = (gstConfig, psd, taxableFrieght, cmpnyTax, FreightCartageOptHamali) => {
  let taxAmount = 0
  let totalAmount = safeNumber(psd.coll_cartage) + safeNumber(psd.del_cartage) + safeNumber(psd.hamali) + safeNumber(psd.op_hamali)
  totalAmount +=
    safeNumber(psd.valuation) + safeNumber(psd.doc_fee) + safeNumber(psd.pickup_fee) + safeNumber(psd.dropoff_fee) + safeNumber(psd.freight)
  if (FreightCartageOptHamali) {
    totalAmount =
      safeNumber(psd.freight) +
      safeNumber(psd.coll_cartage) +
      safeNumber(psd.del_cartage) +
      safeNumber(psd.hamali) +
      safeNumber(psd.op_hamali)
  }
  let taxableAmount = 0
  if (gstConfig?.IsEnableConfig) {
    if (gstConfig.IsFreight) {
      taxableAmount += safeNumber(taxableFrieght)
    }
    if (safeNumber(psd.CCBrkup_cmsn) || safeNumber(psd.CCBrkup_pckp) || safeNumber(psd.CCBrkup_rtrn)) {
      if (gstConfig.IsPickupCart) {
        taxableAmount += safeNumber(psd.CCBrkup_pckp)
      }
      if (gstConfig.IsCommCart) {
        taxableAmount += safeNumber(psd.CCBrkup_cmsn)
      }
      if (gstConfig.IsReturnCart) {
        taxableAmount += safeNumber(psd.CCBrkup_rtrn)
      }
    } else {
      taxableAmount += safeNumber(psd.coll_cartage)
    }
    if (gstConfig.IsDelCart || gstConfig.IsCartDel) {
      taxableAmount += safeNumber(psd.del_cartage)
    }
    if (gstConfig.IsOptHam) {
      taxableAmount += safeNumber(psd.op_hamali)
    }
    if (gstConfig.IsHam) {
      taxableAmount += safeNumber(psd.hamali)
    }
    if (gstConfig.IsVal) {
      taxableAmount += safeNumber(psd.valuation)
    }
    if (gstConfig.IsDocChg) {
      taxableAmount += safeNumber(psd.doc_fee)
    }
    if (gstConfig.IsPickupChg) {
      taxableAmount += safeNumber(psd.pickup_fee)
    }
    if (gstConfig.IsDropoffChg) {
      taxableAmount += safeNumber(psd.dropoff_fee)
    }
  } else {
    taxableAmount = totalAmount - safeNumber(psd.freight) + taxableFrieght
  }

  if (safeNumber(taxableAmount) >= safeNumber(cmpnyTax?.MinTaxAmount) && safeNumber(cmpnyTax?.TaxPct) > 0) {
    // taxAmount = Math.round((safeNumber(taxableAmount) * safeNumber(gstConfig.BookingGSTRate)) / 100)
    taxAmount = (safeNumber(taxableAmount) * safeNumber(gstConfig.BookingGSTRate)) / 100;
  }
  // return [taxAmount, taxableAmount,totalAmount]
  if (FreightCartageOptHamali) {
    totalAmount = 0
    totalAmount = safeNumber(psd.coll_cartage) + safeNumber(psd.del_cartage) + safeNumber(psd.hamali) + safeNumber(psd.op_hamali)
    totalAmount +=
      safeNumber(psd.valuation) +
      safeNumber(psd.doc_fee) +
      safeNumber(psd.pickup_fee) +
      safeNumber(psd.dropoff_fee) +
      safeNumber(psd.freight)
  }
  return [customRound(taxAmount), customRound(taxableAmount), totalAmount]
}